const productSelectors = {
  leftAlignedModules: '.desktop-align--left',
  productLeftText: '.product-gallery-text',
  productRightText: '.product-text',
  productCartFunctions: '.product__cart-functions',
  phoneViewport: 768,
  dropdown: '.toggle',
  dropdownTitle: '.toggle__title',
  floatingButton: '.product-text__floating-cart-button',
};

/**
 * function to check dropdown state and manage other dropdowns
 *
 * @param e event on clicked element
 * @param dropdowns list of DOM elements
 */
const handleDropdownClick = (e, dropdowns) => {
  if (e.target.parentNode.classList.contains('opened') && e.isTrusted) {
    const allSiblings = Array.from(dropdowns).filter((el) => el !== e.target.parentNode);
    allSiblings.forEach((sibling) => {
      if (sibling.classList.contains('opened')) {
        const title = sibling.querySelector(productSelectors.dropdownTitle);
        title.click();
      }
    });
  }
};

/**
 * floating cart button functionality
 */
const runFloatingButton = () => {
  const button = document.querySelector(productSelectors.floatingButton);

  if (!button) return;

  const cartFunctions = document.querySelector(productSelectors.productCartFunctions);

  button.addEventListener('click', () => {
    cartFunctions.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
  });

  const observer = new IntersectionObserver((entries) => {
    entries[0].intersectionRatio !== 0 ? button.classList.add('hidden') : button.classList.remove('hidden');
  });
  observer.observe(cartFunctions);
};

/**
 * move left Aligned Sections if viewport change
 */
const moveLeftAlignedSections = () => {
  const leftSideContainer = document.querySelector(productSelectors.productLeftText);
  let parent = null;

  if (document.body.clientWidth >= productSelectors.phoneViewport && !leftSideContainer.childNodes.length) {
    parent = leftSideContainer;
  }
  if (document.body.clientWidth < productSelectors.phoneViewport && leftSideContainer.childNodes.length) {
    parent = document.querySelector(productSelectors.productRightText);
  }

  if (parent) {
    const leftAlignedModules = document.querySelectorAll(productSelectors.leftAlignedModules);
    leftAlignedModules?.forEach((section) => parent.appendChild(section));
  }
};

/** Observer function to determine viewport size */
const runViewportObserver = () => {
  const obs = new ResizeObserver(() => {
    moveLeftAlignedSections();
  });
  obs.observe(document.querySelector(productSelectors.productLeftText));
};

/** recognise which code should be called at start */
window.addEventListener('DOMContentLoaded', () => {
  const leftAlignedModules = document.querySelectorAll(productSelectors.leftAlignedModules);
  const dropdowns = document.querySelectorAll(productSelectors.dropdown);

  if (leftAlignedModules.length) {
    moveLeftAlignedSections();
    runViewportObserver();
  }

  if (dropdowns.length) {
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('click', (e) => handleDropdownClick(e, dropdowns));
    });
  }

  runFloatingButton();
});
